import { createAction, props } from '@ngrx/store'
import { SignatureTemplate } from '@tv3/containers/inquiries/overlays/inquiry-overlay/automata-booking-overlay/store/signature-template'

export const LoadContracts = createAction('[Contracts] Load Contracts')
export const LoadContractsComplete = createAction(
  '[Contracts] Load Contracts Complete',
  props<{ contracts: SignatureTemplate[] }>()
)
